import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

class UserStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return null;
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.START:
                return action.user;

            case ActionTypes.LOGIN_FINISH:
                return action.user;

            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGIN_START:
            case ActionTypes.LOGIN_FAILED:
            case ActionTypes.LOGOUT:
                return null;

            default:
                return state;
        }
    }
}

export default new UserStore();



// WEBPACK FOOTER //
// src/stores/UserStore.js